
import React from 'react';
import { Link } from 'react-router-dom';

const services = [
  '不動産売買',
  '賃貸仲介',
  '不動産管理',
  '投資相談',
  '住宅ローン相談'
];

const areas = [
  '渋谷区',
  '新宿区',
  '港区',
  '世田谷区',
  '目黒区'
];

const Footer: React.FC = () => {
  return (
    <footer className="bg-gray-800 text-white">
      <div className="container mx-auto px-6 py-12">
        <div className="grid md:grid-cols-4 gap-8">
          <div>
            <h3 className="text-xl font-bold mb-4" style={{ fontFamily: '"Pacifico", serif' }}>
              PM不動産
            </h3>
            <p className="text-gray-300 mb-4">
              地域に根ざした信頼の不動産会社として、お客様の住まい探しをサポートします。
            </p>
            <div className="flex space-x-4">
              <button className="text-gray-300 hover:text-white transition-colors duration-300 cursor-pointer">
                <i className="ri-facebook-fill text-xl"></i>
              </button>
              <button className="text-gray-300 hover:text-white transition-colors duration-300 cursor-pointer">
                <i className="ri-twitter-fill text-xl"></i>
              </button>
              <button className="text-gray-300 hover:text-white transition-colors duration-300 cursor-pointer">
                <i className="ri-instagram-fill text-xl"></i>
              </button>
            </div>
          </div>
          
          <div>
            <h4 className="text-lg font-semibold mb-4">サービス</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/services" className="text-gray-300 hover:text-white transition-colors duration-300 cursor-pointer">
                  売買サポート
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-gray-300 hover:text-white transition-colors duration-300 cursor-pointer">
                  賃貸仲介
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-gray-300 hover:text-white transition-colors duration-300 cursor-pointer">
                  リフォーム
                </Link>
              </li>
              <li>
                <Link to="/search" className="text-gray-300 hover:text-white transition-colors duration-300 cursor-pointer">
                  物件検索
                </Link>
              </li>
            </ul>
          </div>
          
          <div>
            <h4 className="text-lg font-semibold mb-4">会社情報</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/about" className="text-gray-300 hover:text-white transition-colors duration-300 cursor-pointer">
                  会社案内
                </Link>
              </li>
              <li>
                <button className="text-gray-300 hover:text-white transition-colors duration-300 cursor-pointer">
                  スタッフ紹介
                </button>
              </li>
              <li>
                <button className="text-gray-300 hover:text-white transition-colors duration-300 cursor-pointer">
                  対応エリア
                </button>
              </li>
              <li>
                <button className="text-gray-300 hover:text-white transition-colors duration-300 cursor-pointer">
                  採用情報
                </button>
              </li>
            </ul>
          </div>
          
          <div>
            <h4 className="text-lg font-semibold mb-4">お問い合わせ</h4>
            <div className="space-y-2 text-gray-300">
              <p>
                <i className="ri-phone-line mr-2"></i>
                03-1234-5678
              </p>
              <p>
                <i className="ri-mail-line mr-2"></i>
                info@pm-realestate.co.jp
              </p>
              <p>
                <i className="ri-map-pin-line mr-2"></i>
                東京都渋谷区神宮前1-1-1
              </p>
              <p className="text-sm">
                営業時間: 平日 9:00-18:00
              </p>
            </div>
          </div>
        </div>
        
        <div className="border-t border-gray-700 mt-8 pt-8 text-center text-gray-300">
          <p>&copy; 2024 PM不動産. All rights reserved. | 
            <a 
              href="https://readdy.ai/?origin=logo" 
              target="_blank" 
              rel="noopener noreferrer"
              className="hover:text-white transition-colors duration-300 cursor-pointer ml-2"
            >
              Website Builder
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
